
<highcharts :options="chartOptions" :key="JSON.stringify(colors)"></highcharts>
